<template>
  <div
    class="content"
    :class="{ 'h5-coupon-detail': isH5, 'coupon-detail': !isH5 }"
  >
    <!-- 返回按钮 -->
    <GoBack v-if="!showInput && !isElectron" />
    <div class="page-cont-wrap">
      <!-- 兑换码 -->
      <div class="exchange-wrap" v-if="showInput">
        <el-input
          v-model.trim="coupon_code"
          maxlength="30"
          placeholder="请输入兑换码"
        ></el-input>
        <el-button
          type="primary"
          size="medium"
          @click="exchangeByCode"
          v-preventReClick
          :disabled="btnLoading"
          >兑换</el-button
        >
      </div>
      <!-- 优惠券信息 -->
      <div class="coupon-info">
        <p class="name">{{ couponInfo.coupon_name }}</p>
        <p class="face-value" v-if="couponInfo.coupon_type === 1">
          ￥{{ couponInfo.amount / 100 }}
        </p>
        <p class="face-value" v-if="couponInfo.coupon_type === 2">
          {{ couponInfo.ratio / 10 }}折
        </p>
        <p v-if="couponInfo.start_time" class="time">
          可领取时间：
          {{
            moment(couponInfo.start_time * 1000).format("YYYY.MM.DD HH:mm:ss")
          }}
          -
          {{ moment(couponInfo.end_time * 1000).format("YYYY.MM.DD HH:mm:ss") }}
        </p>
        <p>
          可使用时间：
          {{
            moment(couponInfo.use_start_time * 1000).format(
              "YYYY.MM.DD HH:mm:ss"
            )
          }}
          -
          {{
            moment(couponInfo.use_end_time * 1000).format("YYYY.MM.DD HH:mm:ss")
          }}
        </p>
      </div>
      <!-- 课程列表 -->
      <div class="course-list">
        <p class="title">优惠券适用课程</p>
        <div v-if="courseList && courseList.length">
          <CourseCard
            v-for="item in courseList"
            :key="item.id"
            :courseInfo="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseList } from "@saas/server-api/src/course";
import { GoBack, CourseCard, isH5 } from "@saas/components/src";
import moment from "moment";
import { getCouponInfo, addCouponByCode } from "@saas/server-api/src/coupon";
export default {
  data: function () {
    return {
      moment,
      couponInfo: {},
      showInput: false,
      coupon_code: "",
      btnLoading: false,
      courseList: [],
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  mounted() {
    if (this.$route.query.exchange) {
      this.showInput = true;
    }
    this.apiGetCouponInfo();
  },
  methods: {
    apiGetCouponInfo() {
      getCouponInfo({
        id: this.$route.params.id,
      }).then((res) => {
        const { code, data, message } = res;
        if (code === 1) {
          this.couponInfo = data || {};
          // 判断是否停止领取
          let now = new Date().getTime();
          if (data.end_time && data.end_time * 1000 < now) {
            this.$chiralConfirmMessage("活动已结束");
            return false;
          }
          if (data.course_list && data.course_list.length) {
            // 获取课程列表
            let course_id = data.course_list.map((item) => {
              return item.course_id;
            });
            this.apiGetCourseList(course_id);
          }
        } else {
          this.$message.error(message);
        }
      });
    },
    apiGetCourseList(course_id) {
      getCourseList({ course_id: course_id.join(",") }).then((res) => {
        const { code, data = {}, message } = res;
        if (code === 1) {
          this.courseList = data.list || [];
        } else {
          this.$message.error(message);
        }
      });
    },
    exchangeByCode() {
      if (!this.coupon_code) {
        this.$message.warning("请输入兑换码");
        return false;
      }
      if (this.btnLoading) return;
      this.btnLoading = true;
      addCouponByCode({ coupon_code: this.coupon_code })
        .then((res) => {
          const { code, data, message } = res;
          if (code === 1) {
            this.$message.success("兑换成功");
            this.coupon_code = "";
          } else {
            this.$message.error(message);
          }
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
  },
  components: {
    CourseCard,
    GoBack,
  },
};
</script>

<style lang="scss" scoped>
.coupon-detail {
  margin-top: 16px;
  max-width: 768px;
  width: 100%;
  .go-back-wrap {
    padding: 14px 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    width: fit-content;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
    }
    span {
      margin-left: 10px;
    }
  }
  .page-cont-wrap {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
  }
  .exchange-wrap {
    display: flex;
    justify-content: center;
    padding: 0 0 20px 0;
    ::v-deep .el-input input {
      width: 400px;
      height: 32px;
      border-radius: 16px;
      background: rgba($color: #7e868e, $alpha: 0.16);
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 14px;
      color: rgba($color: $chiral-week-color, $alpha: 0.3);
      line-height: 20px;
    }
    .el-input {
      width: 400px;
      margin-right: 8px;
    }
    .el-button {
      width: 88px;
      height: 32px;
      border-radius: 17px;
      font-size: 14px;
      color: #ffffff;
      line-height: 32px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .coupon-info {
    margin-bottom: 32px;
    padding: 20px 0;
    border-radius: 8px;
    background: $activity-color;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 12px;
    }
    .face-value {
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      margin-bottom: 16px;
    }
    .time {
      margin-bottom: 14px;
    }
  }
  .course-list {
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      margin-bottom: 20px;
    }
  }
}

.h5-coupon-detail {
  background: #fff;
  width: 100%;
  padding: 0.21rem;
  .go-back-wrap {
    display: flex;
    align-items: center;
    width: fit-content;
    cursor: pointer;
    padding: 0.21rem 0.27rem;
    font-size: 0.32rem;
    img {
      width: 0.53rem;
      height: 0.53rem;
    }
    span {
      margin-left: 0.27rem;
    }
  }
  .exchange-wrap {
    display: flex;
    justify-content: center;
    padding: 0.53rem 0;
    .el-input {
      width: 6.67rem;
      margin-right: 0.21rem;
    }
    ::v-deep .el-input input {
      width: 6.67rem;
      height: 0.85rem;
      border-radius: 0.16rem;
      background: rgba($color: #7e868e, $alpha: 0.16);
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 0.37rem;
      color: rgba($color: $chiral-week-color, $alpha: 0.3);
      line-height: 0.53rem;
    }
    .el-button {
      width: 1.6rem;
      height: 0.85rem;
      border-radius: 0.4rem;
      font-size: 0.32rem;
      color: #ffffff;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .coupon-info {
    background: $activity-color;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.53rem;
    padding: 0.53rem 0.21rem;
    border-radius: 0.21rem;
    font-size: 0.32rem;
    .name {
      font-size: 0.4rem;
      font-weight: 600;
      margin-bottom: 0.27rem;
    }
    .face-value {
      font-size: 0.53rem;
      font-weight: 800;
      margin-bottom: 0.4rem;
    }
  }
  .course-list {
    .title {
      font-size: 0.43rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 0.27rem;
    }
  }
}
</style>
